import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

const STYLES = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:wght,FILL@100..700,0..1&display=swap');
@import url('https://fonts.googleapis.com/icon?family=Material+Icons+Outlined');

#main-nav {
  position: fixed;
  top: 0; left: 0; right: 0;
  z-index: 9999;
  height: 70px;
  background: rgba(2,18,43,0.88);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  border-bottom: 1px solid rgba(91,164,252,0.12);
  display: flex;
  align-items: center;
  padding: 0 5%;
}
#main-nav .inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
}
#main-nav a.nav-active { color: #5ba4fc !important; }
#main-nav a.nav-active::after {
  content: '';
  position: absolute;
  bottom: -4px; left: 0; right: 0;
  height: 2px;
  background: #5ba4fc;
  border-radius: 999px;
}

#global-bg {
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  overflow: hidden;
  background: #02122b;
}
.gb-blob {
  position: absolute;
  border-radius: 40% 60% 70% 30% / 40% 50% 60% 50%;
  filter: blur(90px);
  opacity: 0.5;
  animation: gbMorph 20s ease-in-out infinite;
}
.gb-blob-1 { width:900px;height:900px;top:-200px;left:-200px;background:radial-gradient(circle at 40% 40%,#0e3b6e,transparent 70%);animation-delay:0s; }
.gb-blob-2 { width:700px;height:700px;bottom:-100px;right:-150px;background:radial-gradient(circle at 60% 60%,#0c4a85,transparent 70%);animation-delay:-7s; }
.gb-blob-3 { width:600px;height:600px;top:35%;left:30%;background:radial-gradient(circle at 50% 50%,#082e58,transparent 70%);animation-delay:-14s; }
.gb-blob-4 { width:500px;height:500px;top:60%;right:25%;background:radial-gradient(circle at 50% 50%,#0a1f45,transparent 70%);animation-delay:-4s; }
#global-bg .grid-tex {
  position:absolute;inset:0;
  background-image:linear-gradient(rgba(91,164,252,0.04) 1px,transparent 1px),linear-gradient(90deg,rgba(91,164,252,0.04) 1px,transparent 1px);
  background-size:60px 60px;
}
#global-bg .scanline {
  position:absolute;left:0;right:0;height:2px;
  background:linear-gradient(90deg,transparent,rgba(91,164,252,0.15),transparent);
  animation:scan 14s linear infinite;
}
@keyframes scan { 0%{top:-2px} 100%{top:100%} }
@keyframes gbMorph {
  0%,100%{border-radius:40% 60% 70% 30%/40% 50% 60% 50%;transform:translate(0,0)}
  33%{border-radius:70% 30% 30% 70%/60% 40% 60% 40%;transform:translate(30px,-40px)}
  66%{border-radius:30% 70% 70% 30%/30% 30% 70% 70%;transform:translate(-20px,30px)}
}

section { position:relative;z-index:1;background:transparent !important; }
section[id] { scroll-margin-top: 70px; }

.watch-container {
  transform: perspective(1200px) rotateY(-12deg) rotateX(6deg);
  transition: transform 0.4s cubic-bezier(0.2, 0.9, 0.4, 1.1);
  filter: drop-shadow(0 25px 25px rgba(0,0,0,0.4));
}
.watch-container:hover {
  transform: perspective(1200px) rotateY(-6deg) rotateX(3deg);
}
.watch-body {
  background: radial-gradient(ellipse at 30% 20%, #1e2a3a, #0a0f1a);
  box-shadow: 
    0 30px 40px -20px rgba(0,0,0,0.8),
    inset 0 1px 2px rgba(255,255,255,0.1),
    0 0 0 6px #2d3a4e,
    0 0 0 12px #1e2a3a;
}
.watch-screen {
  background: radial-gradient(circle at 20% 30%, #0f172a, #030712);
  box-shadow: inset 0 0 20px rgba(0,0,0,0.6), 0 0 0 2px rgba(91,164,252,0.2);
}
.watch-crown {
  background: linear-gradient(135deg, #b9c7d9, #7a8b9f);
  box-shadow: -2px 0 5px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.4);
}
.watch-band {
  background: linear-gradient(145deg, #2c3e4e, #1a2a36);
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.05), 0 8px 20px rgba(0,0,0,0.3);
}

.watch-container-inclined {
  transform: perspective(1200px) rotateX(12deg) rotateY(18deg) rotateZ(-4deg);
  transition: transform 0.4s cubic-bezier(0.2, 0.9, 0.4, 1.1);
  filter: drop-shadow(0 20px 25px rgba(0,0,0,0.4));
}
.watch-container-inclined:hover {
  transform: perspective(1200px) rotateX(8deg) rotateY(12deg) rotateZ(-2deg);
}

.glass-card {
  background: rgba(13,27,46,0.55);
  backdrop-filter: blur(14px);
  border: 1px solid rgba(255,255,255,0.08);
  transition: all 0.3s ease;
  box-shadow: 0 8px 20px -8px rgba(0,0,0,0.4);
}
.glass-card:hover {
  background: rgba(13,27,46,0.8);
  border-color: rgba(91,164,252,0.4);
  transform: translateY(-4px);
  box-shadow: 0 20px 30px -12px rgba(0,0,0,0.5);
}

.phone-mockup-enhanced {
  transition: all 0.4s cubic-bezier(0.2, 0.9, 0.4, 1.1);
  box-shadow: 
    0 30px 40px -20px rgba(0,0,0,0.8),
    0 0 0 3px #334155,
    0 0 0 8px #1e293b;
}
.phone-mockup-enhanced:hover {
  transform: translateY(-12px) rotate(-1deg) scale(1.01);
  z-index: 50;
  box-shadow: 
    0 0 0 3px #475569,
    0 0 0 8px #334155,
    0 0 40px rgba(91,164,252,0.25),
    30px 40px 60px -15px rgba(0,0,0,0.9);
}

.dna-scene { perspective: 1200px; transform-style: preserve-3d; }
.dna-helix-container {
  position: relative; width: 220px; height: 580px;
  transform-style: preserve-3d;
  animation: spinDNA 22s linear infinite;
}
@keyframes spinDNA { 0% { transform: rotateY(0deg); } 100% { transform: rotateY(360deg); } }
.strand {
  position: relative; width: 100%; height: 2px; transform-style: preserve-3d;
  margin: 12px 0;
}
.strand::before, .strand::after {
  content: ''; position: absolute; top: 50%; width: 14px; height: 14px;
  border-radius: 50%; transform: translate(-50%, -50%);
  box-shadow: 0 0 18px currentColor;
}
.strand::before { left: 0; background: #00f0ff; color: #00f0ff; }
.strand::after { right: 0; background: #bc13fe; color: #bc13fe; }
.connector {
  position: absolute; top: 50%; left: 0; right: 0; height: 2px;
  background: linear-gradient(90deg, rgba(0,240,255,0.6), rgba(188,19,254,0.6));
  transform: translateY(-50%);
}

.mesh-blob {
  position:absolute; filter: blur(80px); opacity:0.5;
  animation:float 20s infinite ease-in-out;
}
@keyframes float {
  0% { transform:translate(0,0) rotate(0deg); }
  33% { transform:translate(30px,-50px) rotate(10deg); }
  66% { transform:translate(-20px,20px) rotate(-5deg); }
  100% { transform:translate(0,0) rotate(0deg); }
}

/* Contact section styles */
.contact-input {
  width: 100%;
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.12);
  color: white;
  border-radius: 1rem;
  padding: 0.875rem 1.25rem;
  font-size: 0.95rem;
  transition: all 0.2s ease;
  outline: none;
  font-family: inherit;
}
.contact-input::placeholder { color: rgba(255,255,255,0.3); }
.contact-input:focus {
  background: rgba(255,255,255,0.08);
  border-color: #5ba4fc;
  box-shadow: 0 0 0 3px rgba(91,164,252,0.18);
}
.contact-input option { background: #0b1121; color: white; }
`;

function GlobalBackground() {
  return (
    <div id="global-bg">
      <div className="gb-blob gb-blob-1" />
      <div className="gb-blob gb-blob-2" />
      <div className="gb-blob gb-blob-3" />
      <div className="gb-blob gb-blob-4" />
      <div className="grid-tex" />
      <div className="scanline" />
    </div>
  );
}

function Navbar({ navigate }) {
  return (
    <nav id="main-nav">
      <div className="inner">
        <span className="text-3xl font-bold tracking-tight text-white">CareTech</span>
        <div className="hidden md:flex items-center space-x-8 text-sm font-medium text-gray-300">
          {["home","features","platform","resources","career","contact"].map(s => (
            <a key={s}
               className="hover:text-white transition-colors relative pb-1 capitalize"
               href={`#${s}`}>
              {s.charAt(0).toUpperCase() + s.slice(1)}
            </a>
          ))}
        </div>
        <div className="flex items-center gap-6">
          <button
            onClick={() => navigate("/signin")}
            className="text-sm font-medium text-white hover:text-gray-200 bg-transparent border-none cursor-pointer">
            Sign In
          </button>
        </div>
      </div>
    </nav>
  );
}

function SectionHome({ navigate }) {
  return (
    <section id="home" className="relative" style={{ paddingTop: 70 }}>
      <main className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pt-10 pb-20 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" style={{ minHeight: "calc(100vh - 70px)" }}>
        <div className="flex flex-col justify-center space-y-8 lg:pr-10 order-2 lg:order-1">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold leading-tight tracking-tight">
            <span className="block">REMOTE MONITORING</span>
            <span className="block text-white/90">MEDICAL CLOUD</span>
          </h1>
          <p className="text-lg md:text-xl text-blue-100/80 max-w-lg leading-relaxed font-light">
            Multi-tenant cloud platform for real-time monitoring of vital signs
            (HR, SpO2, Temperature) via Caretech IoT device with secure medical console.
          </p>
          <div className="pt-4">
            <button
              onClick={() => navigate("/signin")}
              className="bg-[#5ba4fc] hover:bg-blue-400 text-white text-base md:text-lg font-semibold px-8 py-3.5 rounded-full transition-all transform hover:-translate-y-1"
              style={{ boxShadow: "0 10px 20px rgba(91,164,252,0.3)" }}>
              Access Medical Console
            </button>
          </div>
        </div>

        <div className="relative order-1 lg:order-2 flex justify-center lg:justify-end items-center h-full">
          <div className="watch-container relative w-[320px] sm:w-[400px] h-[520px] sm:h-[620px]">
            <div className="absolute inset-0 watch-body rounded-[48px] z-10 overflow-hidden">
              <div className="absolute inset-[6px] watch-screen rounded-[42px] overflow-hidden">
                <div className="w-full h-full bg-gradient-to-br from-gray-900/90 to-black/90 relative p-5 text-white flex flex-col justify-between">
                  <div className="flex justify-between items-center text-xs text-gray-400 mb-2">
                    <span className="font-medium tracking-wide">Device UID: CT-45821</span>
                    <div className="flex items-center gap-2">
                      <span className="material-icons-outlined text-[16px]">wifi</span>
                      <span className="material-icons-outlined text-[16px] text-green-500 transform rotate-90">battery_full</span>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4 mb-4">
                    <div className="col-span-2 border-b border-gray-700/60 pb-4">
                      <div className="text-sm text-gray-400 flex items-center gap-1">
                        <span className="material-icons-outlined text-red-500 text-sm animate-pulse">favorite</span> Heart Rate
                      </div>
                      <div className="text-5xl font-mono font-bold tracking-tight">82 bpm</div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-400 mb-1">SpO2</div>
                      <div className="text-3xl font-bold text-green-400">97%</div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-400 mb-1">Temperature</div>
                      <div className="text-3xl font-bold text-yellow-400">36.8°C</div>
                    </div>
                    <div className="col-span-2 text-sm text-green-400 font-semibold bg-green-500/10 p-2 rounded-xl text-center">Status: Normal</div>
                  </div>
                  <div className="bg-red-500/10 border border-red-500/30 rounded-xl p-3 text-red-400 text-sm text-center backdrop-blur-sm">No active alerts</div>
                </div>
              </div>
              <div className="absolute -right-3 top-28 w-6 h-12 watch-crown rounded-r-xl z-20" />
              <div className="absolute -left-3 top-28 w-6 h-12 watch-crown rounded-l-xl z-20" />
            </div>
            <div className="absolute -top-16 left-1/2 -translate-x-1/2 w-10 watch-band h-20 rounded-t-3xl z-0" />
            <div className="absolute -bottom-16 left-1/2 -translate-x-1/2 w-10 watch-band h-20 rounded-b-3xl z-0" />
          </div>
        </div>
      </main>
    </section>
  );
}

function SectionFeatures() {
  return (
    <section id="features" className="relative" style={{ paddingTop: 70 }}>
      <main className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pt-6 pb-20 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center min-h-screen">
        <div className="flex flex-col justify-center space-y-8 lg:pr-6 order-2 lg:order-1">
          <div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight tracking-tight mb-4">
              EMPOWER YOUR <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-300 to-[#5ba4fc]">PATIENT MONITORING</span>
            </h1>
            <p className="text-lg text-blue-100/70 max-w-lg leading-relaxed font-light mb-8">
              Discover the advanced cloud platform designed to monitor vital signs of patients in real-time, manage medical devices, and streamline healthcare operations.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <div className="glass-card p-5 rounded-2xl">
              <div className="flex items-center gap-3 mb-3">
                <div className="p-2 bg-red-500/10 rounded-lg"><span className="material-symbols-outlined text-red-500">ecg_heart</span></div>
                <h3 className="font-semibold text-white">Continuous Vital Signs Monitoring</h3>
              </div>
              <div className="h-16 w-full bg-gray-900/50 rounded-lg border border-gray-800 relative overflow-hidden flex items-end px-1 pb-1">
                {[30,50,40,80,60,45,35,55,70,40].map((h,i) => (
                  <div key={i} className={`w-[10%] rounded-sm mx-[1px] ${i===3?"bg-red-500 animate-pulse":"bg-red-500/50"}`} style={{height:`${h}%`}} />
                ))}
              </div>
              <p className="text-xs text-gray-400 mt-2">Continuous tracking with irregularity alerts.</p>
            </div>
            <div className="glass-card p-5 rounded-2xl">
              <div className="flex items-center gap-3 mb-3">
                <div className="p-2 bg-purple-500/10 rounded-lg"><span className="material-symbols-outlined text-purple-400">bedtime</span></div>
                <h3 className="font-semibold text-white">Respiratory &amp; Health Analysis</h3>
              </div>
              <div className="h-16 w-full flex gap-1">
                <div className="h-full flex-1 bg-gray-900/50 rounded-lg border border-gray-800 flex flex-col justify-end p-2">
                  <div className="flex w-full h-full items-end gap-[2px]">
                    <div className="w-1/4 h-[30%] bg-purple-900 rounded-sm" />
                    <div className="w-1/4 h-[80%] bg-purple-500 rounded-sm" />
                    <div className="w-1/4 h-[50%] bg-purple-700 rounded-sm" />
                    <div className="w-1/4 h-[20%] bg-purple-300 rounded-sm" />
                  </div>
                </div>
              </div>
              <p className="text-xs text-gray-400 mt-2">Detailed breakdown of sleep, respiration, and wellness metrics.</p>
            </div>
            <div className="glass-card p-5 rounded-2xl">
              <div className="flex items-center gap-3 mb-3">
                <div className="p-2 bg-green-500/10 rounded-lg"><span className="material-symbols-outlined text-green-400">map</span></div>
                <h3 className="font-semibold text-white">Device Connectivity &amp; Location Tracking</h3>
              </div>
              <div className="h-16 w-full bg-gray-900/50 rounded-lg border border-gray-800 relative overflow-hidden">
                <svg className="absolute inset-0 w-full h-full p-2" viewBox="0 0 100 40">
                  <path d="M10,30 Q25,10 40,20 T70,15 T90,25" fill="none" stroke="#4ade80" strokeLinecap="round" strokeWidth="2" />
                  <circle className="animate-ping" cx="90" cy="25" fill="#4ade80" r="3" />
                  <circle cx="90" cy="25" fill="#fff" r="1.5" />
                </svg>
              </div>
              <p className="text-xs text-gray-400 mt-2">Monitor device status and patient location securely.</p>
            </div>
            <div className="glass-card p-5 rounded-2xl">
              <div className="flex items-center gap-3 mb-3">
                <div className="p-2 bg-blue-500/10 rounded-lg"><span className="material-symbols-outlined text-blue-400">water_drop</span></div>
                <h3 className="font-semibold text-white">Reliable Device Alerts</h3>
              </div>
              <div className="h-16 w-full bg-gray-900/50 rounded-lg border border-gray-800 relative flex items-center justify-center overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-t from-blue-500/20 to-transparent" />
                <div className="relative z-10 w-8 h-8 bg-gradient-to-br from-blue-300 to-blue-600 shadow-lg shadow-blue-500/50 transform rotate-45 border border-blue-200/30" style={{borderRadius:"50% 50% 50% 0"}} />
                <div className="absolute bottom-0 w-full h-1/2 bg-blue-500/10 blur-sm" />
              </div>
              <p className="text-xs text-gray-400 mt-2">Automatic alerts for device status and patient safety.</p>
            </div>
          </div>
        </div>

        <div className="relative order-1 lg:order-2 flex justify-center lg:justify-end items-center h-full">
          <div className="absolute w-[120%] h-[120%] bg-blue-500/10 rounded-full blur-3xl" style={{zIndex:-1,top:"50%",left:"50%",transform:"translate(-50%,-50%)"}} />
          <div className="watch-container relative w-[300px] sm:w-[380px] h-[500px] sm:h-[600px]">
            <div className="absolute inset-0 watch-body rounded-[48px] z-10 overflow-hidden">
              <div className="absolute inset-[6px] watch-screen rounded-[42px] overflow-hidden">
                <div className="w-full h-full bg-gradient-to-br from-gray-900/95 to-black/95 relative flex flex-col">
                  <div className="absolute inset-0 opacity-30">
                    <svg height="100%" width="100%" xmlns="http://www.w3.org/2000/svg">
                      <defs>
                        <pattern height="40" id="grid-f" patternUnits="userSpaceOnUse" width="40">
                          <path d="M 40 0 L 0 0 0 40" fill="none" stroke="#334155" strokeWidth="1" />
                        </pattern>
                      </defs>
                      <rect fill="url(#grid-f)" height="100%" width="100%" />
                      <path d="M 80 380 L 120 340 L 160 350 L 200 280 L 240 260" fill="none" stroke="#3b82f6" strokeDasharray="10 5" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" />
                      <circle className="animate-ping" cx="160" cy="350" fill="#3b82f6" fillOpacity="0.3" r="10" />
                      <circle cx="160" cy="350" fill="#60a5fa" r="5" stroke="white" strokeWidth="2" />
                    </svg>
                  </div>
                  <div className="relative z-10 px-6 pt-8 flex justify-between items-center bg-gradient-to-b from-black/60 to-transparent pb-4">
                    <span className="text-sm font-bold text-gray-300">10:42 AM</span>
                    <div className="flex gap-1 text-xs">
                      <span className="material-symbols-outlined text-[16px] text-green-400">satellite_alt</span>
                      <span className="text-green-400 font-bold">GPS</span>
                    </div>
                  </div>
                  <div className="relative z-10 mt-auto px-4 pb-8">
                    <div className="bg-black/60 backdrop-blur-xl rounded-2xl p-5 border border-gray-700/50">
                      <div className="flex items-center justify-between mb-3">
                        <div className="flex flex-col">
                          <span className="text-[10px] uppercase text-gray-400 font-bold tracking-wider">Distance</span>
                          <span className="text-3xl font-mono font-bold text-white">5.24 <span className="text-sm text-gray-400 font-sans">km</span></span>
                        </div>
                        <div className="w-12 h-12 rounded-full bg-blue-600 flex items-center justify-center shadow-lg shadow-blue-600/30">
                          <span className="material-symbols-outlined text-white">directions_run</span>
                        </div>
                      </div>
                      <div className="h-[1px] w-full bg-gray-700 my-3" />
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <span className="text-[10px] uppercase text-gray-400 font-bold tracking-wider">Pace</span>
                          <div className="text-2xl font-mono font-bold text-white">5'42"</div>
                        </div>
                        <div>
                          <span className="text-[10px] uppercase text-gray-400 font-bold tracking-wider">HR</span>
                          <div className="text-2xl font-mono font-bold text-red-400 flex items-center gap-1">
                            142 <span className="material-symbols-outlined text-base animate-pulse">favorite</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mt-4 flex justify-center gap-5">
                      <button className="w-12 h-12 rounded-full bg-yellow-500/20 text-yellow-500 flex items-center justify-center border border-yellow-500/50 hover:bg-yellow-500/30 transition">
                        <span className="material-symbols-outlined">pause</span>
                      </button>
                      <button className="w-12 h-12 rounded-full bg-red-500/20 text-red-500 flex items-center justify-center border border-red-500/50 hover:bg-red-500/30 transition">
                        <span className="material-symbols-outlined">stop</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="absolute -right-3 top-28 w-6 h-12 watch-crown rounded-r-xl z-20" />
              <div className="absolute -left-3 top-28 w-6 h-12 watch-crown rounded-l-xl z-20" />
            </div>
            <div className="absolute -top-16 left-1/2 -translate-x-1/2 w-10 watch-band h-20 rounded-t-3xl z-0" />
            <div className="absolute -bottom-16 left-1/2 -translate-x-1/2 w-10 watch-band h-20 rounded-b-3xl z-0" />
          </div>
        </div>
      </main>
    </section>
  );
}

const DNA_STRANDS = [
  {w:40,z:0,rev:false},{w:90,z:20,rev:false},{w:140,z:40,rev:false},
  {w:180,z:60,rev:false},{w:200,z:80,rev:false},{w:180,z:60,rev:false},
  {w:140,z:40,rev:false},{w:90,z:20,rev:false},{w:40,z:0,rev:false},
  {w:90,z:-20,rev:true},{w:140,z:-40,rev:true},{w:180,z:-60,rev:true},
  {w:200,z:-80,rev:true},{w:180,z:-60,rev:true},{w:140,z:-40,rev:true},
  {w:90,z:-20,rev:true},{w:40,z:0,rev:true},
];

function SectionPlatform() {
  return (
    <section id="platform" className="relative overflow-hidden" style={{ paddingTop: 70 }}>
      <main className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 pt-32 pb-20 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center min-h-screen">
        <div className="lg:col-span-7 flex flex-col justify-center relative">
          <div className="relative z-20 mb-16 lg:mb-24 text-center lg:text-left">
            <div className="inline-block px-3 py-1 mb-6 rounded-full bg-blue-500/10 border border-blue-500/20 backdrop-blur-sm">
              <span className="text-xs font-semibold tracking-wider text-blue-300 uppercase">Intelligent Medical Monitoring</span>
            </div>
            <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-extrabold leading-tight tracking-tight mb-6 uppercase">
              Your Vital Signs,<br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-purple-400 to-cyan-400">Connected In Real Time.</span>
            </h1>
            <p className="text-lg md:text-xl text-slate-400 max-w-2xl leading-relaxed font-light mb-10 mx-auto lg:mx-0">
              CareTech Cloud securely connects patients, doctors, and IoT medical devices into one unified ecosystem. Monitor respiratory conditions, receive instant alerts, and enable proactive medical intervention anytime, anywhere.
            </p>
            <div className="flex flex-wrap justify-center lg:justify-start gap-5">
              {[
                { label:"App Store", sub:"Download on the", img:"https://lh3.googleusercontent.com/aida-public/AB6AXuDBNhP-X3V7jG3R5Fj7fP_RJRZXSK8veB2_P3fP_bDnBjudiiTXi9mS135IGsGgwHf3IR4fSFCJyXosozfPaBnYsWQQ_A2wkNRQgt3hYRH0vaHfL42pN5aZkKYYNniJCatrAC2wEbmd2gsKRrrpFdMQi9vSzYpzzhrAIXh7zH8QGTpnA6mrBvy1wM1VeHJKbrzEowavzljVWy_hWkMIqZobczK7RJZOudTfAUnmBsEfX3WVDHsDU-G7X0SxzPdAlqc6rcqi2RAjGw6F", invert:true },
                { label:"Google Play", sub:"Get it on", img:"https://lh3.googleusercontent.com/aida-public/AB6AXuAaJJmWHEedW0ST3Sfzt4O5fpBEavvNl3zF8-tbK1Vn-aChnykGlVpqg_dCAOmaM18XIfq272UdQ9vYGCd4Ar3CRAPTP1L29wHcoP36yeBL-U5GQHWYZebgxQ4FP4Y9UjpBzm6mH1dS2VS6wckxqe7EwdBZywoOLponvtMKXvosQwCTRyTn51LvA4c-dglXW94m5lvJYFwaIKXS9wz-2EdGSLLOAA4sByM3oNar8nm1iUooSJErkm0VtzqglTS6sMWWUNW37ety4BXn", invert:false },
              ].map(({label,sub,img,invert}) => (
                <button key={label} className="group bg-slate-950/80 hover:bg-black text-white px-6 py-3 rounded-2xl flex items-center gap-4 border border-slate-800 hover:border-slate-600 transition-all hover:-translate-y-1 shadow-xl backdrop-blur-sm">
                  <img alt={label} className={`${label==="App Store"?"w-8 h-8":"w-7 h-7"} ${invert?"filter invert":""} group-hover:scale-110 transition-transform`} src={img} />
                  <div className="text-left">
                    <div className="text-[10px] uppercase tracking-wider text-slate-400">{sub}</div>
                    <div className="text-lg font-bold leading-none font-display">{label}</div>
                  </div>
                </button>
              ))}
            </div>
          </div>

          <div className="relative h-[500px] w-full max-w-2xl mx-auto lg:mx-0" style={{perspective:"1000px"}}>
            {/* Back phone */}
            <div className="absolute left-[10%] top-12 phone-mockup-enhanced w-[260px] bg-gray-900 rounded-[2.5rem] overflow-hidden transform -rotate-6 z-10 origin-bottom-right opacity-90 hover:opacity-100 scale-95 hover:scale-100 border-[6px] border-slate-800">
              <div className="absolute top-4 left-1/2 -translate-x-1/2 w-4 h-4 bg-black rounded-full z-20" />
              <div className="w-full h-full bg-[#0b1121] p-4 pt-10 overflow-hidden relative">
                <div className="flex justify-between items-center mb-6 px-1">
                  <div>
                    <div className="text-xs text-slate-400 font-medium">WED 24</div>
                    <div className="text-lg font-bold text-white leading-tight">Dashboard</div>
                  </div>
                  <div className="w-8 h-8 rounded-full bg-gradient-to-tr from-purple-500 to-blue-600 flex items-center justify-center text-[10px] font-bold">JD</div>
                </div>
                <div className="bg-slate-800/40 backdrop-blur-sm rounded-2xl p-4 mb-4 border border-slate-700/50">
                  <div className="flex justify-between items-center mb-4">
                    <span className="text-xs font-semibold text-slate-300 flex items-center gap-1">
                      <span className="material-symbols-outlined text-sm text-green-400">local_fire_department</span> Calories
                    </span>
                    <span className="text-xs text-green-400 font-bold bg-green-400/10 px-2 py-0.5 rounded-full">+12%</span>
                  </div>
                  <div className="h-32 flex items-end justify-between gap-1.5 px-1">
                    {[40,60,85,50,70,45].map((h,i) => (
                      <div key={i} className="w-full rounded-t-sm" style={{
                        height:`${h}%`,
                        background: i===2 ? "linear-gradient(to top,#22c55e,#4ade80)" : "rgba(51,65,85,0.3)"
                      }}>
                        {i===2 && <div className="relative"><div className="absolute -top-6 left-1/2 -translate-x-1/2 text-[9px] font-bold text-white bg-slate-800 px-1.5 py-0.5 rounded border border-slate-700">2400</div></div>}
                      </div>
                    ))}
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-3 mb-4">
                  <div className="bg-gradient-to-br from-indigo-900/40 to-slate-800/40 p-3 rounded-2xl border border-indigo-500/20">
                    <span className="material-symbols-outlined text-indigo-400 mb-2">water_drop</span>
                    <div className="text-xl font-bold text-white">1.8L</div>
                    <div className="text-[10px] text-slate-400">Water Intake</div>
                  </div>
                  <div className="bg-gradient-to-br from-purple-900/40 to-slate-800/40 p-3 rounded-2xl border border-purple-500/20">
                    <span className="material-symbols-outlined text-purple-400 mb-2">bedtime</span>
                    <div className="text-xl font-bold text-white">7h 20m</div>
                    <div className="text-[10px] text-slate-400">Sleep Quality</div>
                  </div>
                </div>
                <div className="bg-slate-800/40 rounded-2xl p-3 flex items-center justify-between border border-slate-700/50">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl bg-orange-500/20 flex items-center justify-center text-orange-400"><span className="material-symbols-outlined">directions_run</span></div>
                    <div>
                      <div className="text-sm font-bold text-white">Morning Run</div>
                      <div className="text-[10px] text-slate-400">5.2 km • 32 min</div>
                    </div>
                  </div>
                  <span className="material-symbols-outlined text-slate-500 text-sm">chevron_right</span>
                </div>
              </div>
            </div>

            {/* Front phone */}
            <div className="absolute left-[35%] top-0 phone-mockup-enhanced w-[280px] bg-black rounded-[3rem] overflow-hidden transform rotate-3 z-30 shadow-2xl border-[8px] border-slate-800">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-7 bg-black rounded-b-2xl z-20 flex items-center justify-center">
                <div className="w-16 h-1 bg-gray-900 rounded-full" />
              </div>
              <div className="w-full h-full bg-gradient-to-b from-[#0f172a] to-[#020617] p-4 pt-12 overflow-hidden relative">
                <div className="flex justify-between items-end mb-6 px-1">
                  <h2 className="text-2xl font-display font-bold text-white">Summary</h2>
                  <div className="w-8 h-8 rounded-full bg-slate-800 border border-slate-700 flex items-center justify-center">
                    <span className="material-symbols-outlined text-blue-400 text-sm">person</span>
                  </div>
                </div>
                <div className="bg-[#1e293b]/50 backdrop-blur-md rounded-3xl p-5 mb-5 border border-white/5 relative overflow-hidden">
                  <div className="absolute top-0 right-0 w-32 h-32 bg-blue-500/10 blur-3xl rounded-full" />
                  <div className="flex items-center gap-6">
                    <div className="relative w-24 h-24 flex-shrink-0">
                      <div className="absolute inset-0 rounded-full border-[6px] border-red-900/30" />
                      <div className="absolute inset-0 rounded-full border-[6px] border-red-500 border-t-transparent border-l-transparent transform -rotate-45" style={{clipPath:"polygon(0 0,100% 0,100% 100%,50% 100%)"}} />
                      <div className="absolute inset-2 rounded-full border-[6px] border-green-900/30" />
                      <div className="absolute inset-2 rounded-full border-[6px] border-green-500 border-r-transparent transform rotate-12" style={{clipPath:"polygon(0 0,100% 0,100% 50%,0 50%)"}} />
                      <div className="absolute inset-4 rounded-full border-[6px] border-blue-900/30" />
                      <div className="absolute inset-4 rounded-full border-[6px] border-blue-500 border-b-transparent transform rotate-90" style={{clipPath:"polygon(50% 0,100% 0,100% 100%,50% 100%)"}} />
                    </div>
                    <div>
                      {[{c:"red",l:"Move",v:"340/500"},{c:"green",l:"Exercise",v:"24/30"},{c:"blue",l:"Stand",v:"8/12"}].map(({c,l,v})=>(
                        <div key={l} className="mb-2">
                          <div className={`text-[10px] text-${c}-400 font-bold uppercase tracking-wide`}>{l}</div>
                          <div className="text-xl font-display font-bold text-white">{v}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="space-y-3">
                  <div className="bg-[#1e293b]/40 backdrop-blur-md rounded-2xl p-4 border border-white/5 flex items-center justify-between cursor-pointer hover:bg-[#1e293b]/60 transition-colors">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-red-500/20 flex items-center justify-center"><span className="material-symbols-outlined text-red-500">ecg_heart</span></div>
                      <div>
                        <div className="text-xs font-semibold text-slate-400 uppercase">Heart Rate</div>
                        <div className="text-lg font-bold text-white">68 BPM</div>
                      </div>
                    </div>
                    <div className="h-8 w-16 flex items-end gap-1">
                      {[40,60,100,50,30].map((h,i)=>(
                        <div key={i} className={`w-1/5 rounded-sm ${i===2?"bg-red-500 shadow-[0_0_8px_rgba(239,68,68,0.5)]":i===1?"bg-red-500/50":i===3?"bg-red-500/40":"bg-red-500/20"}`} style={{height:`${h}%`}} />
                      ))}
                    </div>
                  </div>
                  <div className="bg-[#1e293b]/40 backdrop-blur-md rounded-2xl p-4 border border-white/5 flex items-center justify-between cursor-pointer hover:bg-[#1e293b]/60 transition-colors">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-cyan-500/20 flex items-center justify-center"><span className="material-symbols-outlined text-cyan-400">spo2</span></div>
                      <div>
                        <div className="text-xs font-semibold text-slate-400 uppercase">Blood Oxygen</div>
                        <div className="text-lg font-bold text-white">98%</div>
                      </div>
                    </div>
                    <span className="text-xs text-slate-500">2m ago</span>
                  </div>
                </div>
                <div className="absolute bottom-0 left-0 w-full p-4 bg-[#0f172a]/90 backdrop-blur-xl border-t border-white/5">
                  <div className="flex justify-between px-4">
                    {[{icon:"home_health",label:"Summary",active:true},{icon:"grid_view",label:"Browse"},{icon:"share",label:"Sharing"}].map(({icon,label,active})=>(
                      <div key={label} className={`flex flex-col items-center gap-1 ${active?"text-blue-500":"text-slate-500"}`}>
                        <span className="material-symbols-outlined text-2xl">{icon}</span>
                        <span className="text-[9px]">{label}</span>
                      </div>
                    ))}
                  </div>
                  <div className="w-32 h-1 bg-slate-700 rounded-full mx-auto mt-4" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right col: DNA */}
        <div className="lg:col-span-5 h-[600px] flex items-center justify-center relative mt-12 lg:mt-0" style={{perspective:"1000px"}}>
          <div className="absolute w-[80%] h-[80%] bg-gradient-to-tr from-blue-600/20 to-purple-600/20 rounded-full blur-[100px]" style={{zIndex:-1,animation:"pulse 2s infinite"}} />
          <div className="dna-scene w-full h-full flex items-center justify-center">
            <div className="dna-helix-container">
              <div className="absolute top-0 left-0 w-full h-full flex flex-col justify-between items-center py-4">
                {DNA_STRANDS.map(({w,z,rev},i)=>(
                  <div key={i} className="strand" style={{width:w,transform:`translateZ(${z}px)`}}>
                    <div className="connector" style={rev?{background:"linear-gradient(90deg,#bc13fe,#00f0ff)"}:{}} />
                  </div>
                ))}
              </div>
            </div>
            <div className="absolute top-[20%] right-0 p-3 bg-slate-900/60 backdrop-blur-md border border-cyan-500/30 rounded-xl animate-bounce" style={{animationDuration:"4s",boxShadow:"0 0 30px rgba(0,240,255,0.15)"}}>
              <div className="flex items-center gap-2">
                <span className="material-symbols-outlined text-cyan-400">genetics</span>
                <div>
                  <div className="text-[10px] text-cyan-200 uppercase tracking-wider">Analysis</div>
                  <div className="text-sm font-bold text-white">Genotype Match</div>
                </div>
              </div>
            </div>
            <div className="absolute bottom-[25%] left-0 p-3 bg-slate-900/60 backdrop-blur-md border border-purple-500/30 rounded-xl animate-bounce" style={{animationDuration:"5s",animationDelay:"1.5s",boxShadow:"0 0 30px rgba(188,19,254,0.15)"}}>
              <div className="flex items-center gap-2">
                <span className="material-symbols-outlined text-purple-400">monitoring</span>
                <div>
                  <div className="text-[10px] text-purple-200 uppercase tracking-wider">Trends</div>
                  <div className="text-sm font-bold text-white">Optimal Health</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </section>
  );
}

function SectionResources() {
  const cards = [
    { icon:"menu_book", color:"blue", title:"Clinical Documentation", desc:"System architecture, medical device onboarding, and cloud deployment manuals.", link:"Download Docs" },
    { icon:"play_circle", color:"red", title:"Platform Tutorials", desc:"Guided walkthroughs of dashboards, alert systems, and patient analytics.", link:"Watch Training" },
    { icon:"article", color:"green", title:"Medical Insights", desc:"Research articles on respiratory monitoring and preventive care technologies.", link:"Read Articles" },
    { icon:"forum", color:"purple", title:"Professional Network", desc:"Connect with doctors, biomedical engineers, and healthcare administrators.", link:"Join Network" },
  ];
  const colorMap = {
    blue:"text-blue-400 bg-blue-500/10",
    red:"text-red-500 bg-red-500/10",
    green:"text-green-400 bg-green-500/10",
    purple:"text-purple-400 bg-purple-500/10"
  };

  return (
    <section id="resources" className="relative" style={{ paddingTop: 70 }}>
      <main className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pt-6 pb-20 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center min-h-screen">
        <div className="flex flex-col justify-center space-y-8 lg:pr-6 order-2 lg:order-1">
          <div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight tracking-tight mb-4">
              RESOURCES &amp; <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-300 to-[#5ba4fc] uppercase">Medical Documentation</span>
            </h1>
            <p className="text-lg text-blue-100/70 max-w-lg leading-relaxed font-light mb-8">
              Access CareTech Cloud documentation, IoT respiratory device integration guides, and secure clinical monitoring resources designed for healthcare professionals.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {cards.map(({icon,color,title,desc,link})=>(
              <div key={title} className="glass-card p-6 rounded-2xl">
                <div className="flex items-center gap-4 mb-3">
                  <div className={`p-3 rounded-xl ${colorMap[color].split(" ")[1]}`}>
                    <span className={`material-symbols-outlined text-3xl ${colorMap[color].split(" ")[0]}`}>{icon}</span>
                  </div>
                  <h3 className="font-bold text-white text-xl">{title}</h3>
                </div>
                <p className="text-sm text-gray-400">{desc}</p>
                <button className="mt-4 inline-flex items-center text-[#5ba4fc] text-sm font-semibold hover:underline bg-transparent border-none cursor-pointer p-0">
                  {link} <span className="material-symbols-outlined text-xs ml-1">chevron_right</span>
                </button>
              </div>
            ))}
          </div>
        </div>

        <div className="relative order-1 lg:order-2 flex justify-center lg:justify-end items-center h-full">
          <div className="absolute w-[120%] h-[120%] bg-blue-500/10 rounded-full blur-3xl" style={{zIndex:-1,top:"50%",left:"50%",transform:"translate(-50%,-50%)"}} />
          <div className="watch-container-inclined relative w-[280px] sm:w-[350px] h-[550px]">
            <div className="absolute inset-0 watch-body rounded-[48px] z-10 overflow-hidden">
              <div className="absolute inset-[6px] watch-screen rounded-[42px] overflow-hidden">
                <div className="w-full h-full bg-slate-900/95 relative flex flex-col p-6">
                  <div className="flex justify-between items-center mb-6">
                    <span className="material-symbols-outlined text-[#5ba4fc] text-lg">medical_services</span>
                    <span className="text-[10px] font-bold text-gray-500">CARETECH SUPPORT</span>
                    <span className="material-symbols-outlined text-gray-500 text-lg">close</span>
                  </div>
                  <div className="space-y-4">
                    <h4 className="text-sm font-bold text-white">Medical Assistance Center</h4>
                    <div className="bg-gray-800/50 p-3 rounded-xl border border-gray-700 flex items-center gap-3">
                      <span className="material-symbols-outlined text-[#5ba4fc] text-sm">search</span>
                      <span className="text-[10px] text-gray-400">Search documentation...</span>
                    </div>
                    <div className="space-y-2 mt-4">
                      {[
                        {icon:"device_hub",color:"text-blue-400",bg:"bg-blue-600/20 border-blue-500/30",label:"Device Integration"},
                        {icon:"sync_problem",color:"text-green-400",bg:"bg-gray-800/40 border-gray-700/50",label:"Data Sync Errors"},
                        {icon:"build",color:"text-orange-400",bg:"bg-gray-800/40 border-gray-700/50",label:"Device Maintenance"},
                      ].map(({icon,color,bg,label})=>(
                        <div key={label} className={`p-3 rounded-xl flex items-center justify-between border ${bg}`}>
                          <div className="flex items-center gap-2">
                            <span className={`material-symbols-outlined text-sm ${color}`}>{icon}</span>
                            <span className="text-[10px] font-medium">{label}</span>
                          </div>
                          <span className="material-symbols-outlined text-[10px]">chevron_right</span>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="mt-auto pt-4 text-center border-t border-gray-800">
                    <span className="text-[9px] text-gray-400">Live technical support available</span>
                  </div>
                </div>
              </div>
              <div className="absolute -right-3 top-24 w-5 h-10 watch-crown rounded-r-xl z-20" />
              <div className="absolute -left-3 top-24 w-5 h-10 watch-crown rounded-l-xl z-20" />
            </div>
            <div className="absolute -top-14 left-1/2 -translate-x-1/2 w-9 watch-band h-16 rounded-t-3xl z-0" />
            <div className="absolute -bottom-14 left-1/2 -translate-x-1/2 w-9 watch-band h-16 rounded-b-3xl z-0" />
          </div>
        </div>
      </main>
    </section>
  );
}

function SectionCareer() {
  const jobs = [
    { title:"Biomedical Systems Engineer", loc:"Remote / Europe" },
    { title:"Full Stack Cloud Developer",  loc:"Remote / North America" },
    { title:"Healthcare Product Manager",  loc:"Hybrid / London, UK" },
  ];

  return (
    <section id="career" className="relative" style={{ paddingTop: 70 }}>
      <main className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pt-6 pb-20 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center min-h-screen">
        <div className="flex flex-col justify-center space-y-8 lg:pr-6 order-2 lg:order-1">
          <div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight tracking-tight mb-4 uppercase">
              JOIN THE FUTURE <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-300 to-[#5ba4fc]">OF DIGITAL HEALTHCARE</span>
            </h1>
            <p className="text-lg text-blue-100/70 max-w-lg leading-relaxed font-light mb-8">
              We are building next-generation cloud solutions for remote patient monitoring and IoT medical integration. Join our team of engineers, clinicians, and innovators shaping the future of connected healthcare.
            </p>
          </div>
          <div className="space-y-4">
            <h2 className="text-xs font-bold tracking-[0.2em] text-[#5ba4fc] uppercase">Open Positions</h2>
            <div className="grid grid-cols-1 gap-4">
              {jobs.map(({title,loc})=>(
                <div key={title} className="glass-card p-5 rounded-2xl flex justify-between items-center">
                  <div>
                    <h3 className="font-bold text-white text-lg">{title}</h3>
                    <div className="flex items-center gap-2 mt-1 text-gray-400 text-sm">
                      <span className="material-symbols-outlined text-sm">location_on</span>
                      <span>{loc}</span>
                    </div>
                  </div>
                  <button className="bg-[#5ba4fc]/10 hover:bg-[#5ba4fc] text-[#5ba4fc] hover:text-white px-5 py-2 rounded-full text-sm font-semibold transition-all flex items-center gap-2 border-none cursor-pointer">
                    Apply Now <span className="material-symbols-outlined text-sm">arrow_forward</span>
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="relative order-1 lg:order-2 flex justify-center lg:justify-end items-center h-full">
          <div className="absolute w-[120%] h-[120%] bg-blue-500/10 rounded-full blur-3xl" style={{zIndex:-1,top:"50%",left:"50%",transform:"translate(-50%,-50%)"}} />
          <div className="watch-container-inclined relative w-[280px] sm:w-[350px] h-[550px]">
            <div className="absolute inset-0 watch-body rounded-[48px] z-10 overflow-hidden">
              <div className="absolute inset-[6px] watch-screen rounded-[42px] overflow-hidden">
                <div className="w-full h-full bg-slate-900/95 relative flex flex-col">
                  <div className="p-6 pb-2">
                    <div className="flex justify-between items-center mb-6">
                      <span className="material-symbols-outlined text-[#5ba4fc] text-lg">groups</span>
                      <span className="text-[10px] font-bold text-gray-500">CARETECH TEAM</span>
                      <span className="material-symbols-outlined text-gray-500 text-lg">more_vert</span>
                    </div>
                    <h4 className="text-sm font-bold text-white mb-4">Life at CareTech</h4>
                    <div className="space-y-3">
                      <div className="relative rounded-xl overflow-hidden aspect-video bg-gray-800 border border-gray-700">
                        <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent flex items-end p-2">
                          <span className="text-[8px] font-medium text-white">Clinical Innovation Summit 2026</span>
                        </div>
                        <div className="w-full h-full flex items-center justify-center">
                          <span className="material-symbols-outlined text-[#5ba4fc]/40 text-3xl">photo_library</span>
                        </div>
                      </div>
                      <div className="bg-blue-600/10 p-3 rounded-xl border border-blue-500/30">
                        <div className="flex items-center gap-2 mb-1">
                          <span className="material-symbols-outlined text-[#5ba4fc] text-xs">workspace_premium</span>
                          <span className="text-[10px] font-bold text-white uppercase">New Milestone</span>
                        </div>
                        <p className="text-[9px] text-gray-400">10,000+ patients actively monitored through CareTech Cloud.</p>
                      </div>
                    </div>
                  </div>
                  <div className="mt-auto p-4 bg-gray-900/80 border-t border-gray-800">
                    <div className="flex items-center justify-between mb-2">
                      <span className="text-[9px] text-gray-400 font-bold uppercase tracking-wider">Team Online</span>
                      <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
                    </div>
                    <div className="flex -space-x-2">
                      {[{bg:"bg-blue-400",t:"DR"},{bg:"bg-green-400",t:"IT"},{bg:"bg-purple-400",t:"UX"},{bg:"bg-pink-400",t:"AI"},{bg:"bg-gray-700",t:"+8",white:true}].map(({bg,t,white})=>(
                        <div key={t} className={`w-8 h-8 rounded-full ${bg} border-2 border-slate-900 flex items-center justify-center text-[10px] font-bold ${white?"text-white":"text-black"}`}>{t}</div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="absolute -right-3 top-24 w-5 h-10 watch-crown rounded-r-xl z-20" />
              <div className="absolute -left-3 top-24 w-5 h-10 watch-crown rounded-l-xl z-20" />
            </div>
            <div className="absolute -top-14 left-1/2 -translate-x-1/2 w-9 watch-band h-16 rounded-t-3xl z-0" />
            <div className="absolute -bottom-14 left-1/2 -translate-x-1/2 w-9 watch-band h-16 rounded-b-3xl z-0" />
          </div>
        </div>
      </main>
    </section>
  );
}

function SectionContact() {
  const [form, setForm] = useState({ name:"", email:"", subject:"", message:"" });
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [apiErrors, setApiErrors] = useState([]);

  const handleChange = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    setStatus("loading");
    setApiErrors([]);
    try {
      const res = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...form,
          subject: form.subject || "Technical Support",
        }),
      });
      const data = await res.json();
      if (!res.ok || !data.success) {
        setApiErrors(data.errors ?? ["Something went wrong."]);
        setStatus("error");
      } else {
        setStatus("success");
      }
    } catch {
      setApiErrors(["Network error — please try again."]);
      setStatus("error");
    }
  };

  const contactMethods = [
    { icon:"alternate_email", color:"text-blue-400",  bg:"bg-blue-500/10",  label:"Email Support",        value:"support@caretech.io" },
    { icon:"location_on",     color:"text-green-400", bg:"bg-green-500/10", label:"Headquarters",         value:"101 MedTech Drive, Paris, France" },
    { icon:"support_agent",   color:"text-purple-400",bg:"bg-purple-500/10",label:"24/7 Clinical Hotline", value:"+216 29 427 196" },
  ];

  return (
    <section id="contact" className="relative" style={{ paddingTop: 70 }}>
      <main className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pt-6 pb-24 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center min-h-screen">

        {/* Left: info */}
        <div className="flex flex-col justify-center space-y-10 order-2 lg:order-1">
          <div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight tracking-tight mb-4 uppercase">
              GET IN <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-300 to-[#5ba4fc]">TOUCH WITH US</span>
            </h1>
            <p className="text-lg text-blue-100/70 max-w-lg leading-relaxed font-light">
              Have questions about CareTech Cloud, IoT device integration, or clinical monitoring solutions? Our medical technology team is ready to help.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-4">
            {contactMethods.map(({ icon, color, bg, label, value }) => (
              <div key={label} className="glass-card p-5 rounded-2xl flex items-center gap-5">
                <div className={`p-3 rounded-xl flex-shrink-0 ${bg}`}>
                  <span className={`material-symbols-outlined text-2xl ${color}`}>{icon}</span>
                </div>
                <div>
                  <p className="text-xs font-bold tracking-widest text-gray-500 uppercase">{label}</p>
                  <p className="text-white font-semibold mt-0.5">{value}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="glass-card p-6 rounded-2xl flex items-center justify-between gap-4 relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-blue-600/10 to-purple-600/10 pointer-events-none" />
            <div className="relative z-10">
              <h3 className="text-white font-bold text-lg">Join the Medical Network</h3>
              <p className="text-gray-400 text-sm mt-1">Connect with 10,000+ healthcare professionals.</p>
              <button className="mt-4 px-5 py-2 bg-[#5ba4fc]/10 hover:bg-[#5ba4fc] border border-[#5ba4fc]/30 text-[#5ba4fc] hover:text-white rounded-full text-sm font-semibold transition-all flex items-center gap-2">
                Explore Network <span className="material-symbols-outlined text-sm">arrow_forward</span>
              </button>
            </div>
            <div className="relative z-10 flex-shrink-0 hidden sm:flex flex-col items-center gap-2">
              {[{bg:"bg-blue-400",t:"DR"},{bg:"bg-green-400",t:"RN"},{bg:"bg-purple-400",t:"PT"},{bg:"bg-pink-400",t:"BM"}].map(({bg,t}) => (
                <div key={t} className={`w-9 h-9 rounded-full ${bg} border-2 border-slate-900 flex items-center justify-center text-[10px] font-bold text-black`}>{t}</div>
              ))}
            </div>
          </div>
        </div>

        {/* Right: form */}
        <div className="relative order-1 lg:order-2 flex justify-center lg:justify-end items-start h-full">
          <div className="absolute w-[120%] h-[120%] bg-blue-500/10 rounded-full blur-3xl" style={{zIndex:-1,top:"50%",left:"50%",transform:"translate(-50%,-50%)"}} />

          <div className="glass-card w-full max-w-lg rounded-3xl p-8 md:p-10 space-y-6">
            <div className="mb-2">
              <h2 className="text-2xl font-extrabold text-white tracking-tight">Send a Message</h2>
              <div className="h-1 w-12 bg-[#5ba4fc] mt-3 rounded-full" />
            </div>

            {status === "success" ? (
              <div className="flex flex-col items-center justify-center py-16 gap-5 text-center">
                <div className="w-16 h-16 rounded-full bg-green-500/10 border border-green-500/30 flex items-center justify-center">
                  <span className="material-symbols-outlined text-green-400 text-3xl">check_circle</span>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white">Message Sent!</h3>
                  <p className="text-gray-400 text-sm mt-2 max-w-xs">Our clinical team will get back to you within 24 hours.</p>
                </div>
                <button
                  onClick={() => { setStatus("idle"); setApiErrors([]); setForm({ name:"", email:"", subject:"", message:"" }); }}
                  className="mt-2 px-6 py-2.5 rounded-full border border-[#5ba4fc]/40 text-[#5ba4fc] text-sm font-semibold hover:bg-[#5ba4fc]/10 transition-all bg-transparent cursor-pointer">
                  Send Another
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-5">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                  <div className="space-y-1.5">
                    <label className="text-xs font-bold tracking-widest text-gray-500 uppercase">Full Name</label>
                    <input
                      name="name" value={form.name} onChange={handleChange}
                      className="contact-input" placeholder="Dr. John Doe" type="text" required />
                  </div>
                  <div className="space-y-1.5">
                    <label className="text-xs font-bold tracking-widest text-gray-500 uppercase">Email Address</label>
                    <input
                      name="email" value={form.email} onChange={handleChange}
                      className="contact-input" placeholder="dr.john@hospital.com" type="email" required />
                  </div>
                </div>

                <div className="space-y-1.5">
                  <label className="text-xs font-bold tracking-widest text-gray-500 uppercase">Subject</label>
                  <select
                    name="subject" value={form.subject} onChange={handleChange}
                    className="contact-input cursor-pointer">
                    <option value="Technical Support">Technical Support</option>
                    <option value="Device Integration">Device Integration</option>
                    <option value="Sales Inquiry">Sales Inquiry</option>
                    <option value="Clinical Partnership">Clinical Partnership</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                <div className="space-y-1.5">
                  <label className="text-xs font-bold tracking-widest text-gray-500 uppercase">Your Message</label>
                  <textarea
                    name="message" value={form.message} onChange={handleChange}
                    className="contact-input resize-none" rows={5}
                    placeholder="How can we assist your clinical team?" required />
                </div>

                {/* API error banner */}
                {status === "error" && apiErrors.length > 0 && (
                  <div className="text-red-400 text-sm bg-red-500/10 border border-red-500/30 rounded-xl p-3 flex items-start gap-2">
                    <span className="material-symbols-outlined text-base mt-0.5">error</span>
                    <ul className="list-none m-0 p-0 space-y-0.5">
                      {apiErrors.map((err, i) => <li key={i}>{err}</li>)}
                    </ul>
                  </div>
                )}

                <button
                  type="submit"
                  disabled={status === "loading"}
                  className="w-full py-4 bg-[#5ba4fc] hover:bg-blue-400 text-white font-bold text-base rounded-full transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2 border-none cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:translate-y-0"
                  style={{ boxShadow:"0 10px 30px rgba(91,164,252,0.35)" }}>
                  {status === "loading" ? (
                    <>
                      <span className="animate-spin material-symbols-outlined text-sm">autorenew</span>
                      <span>Sending...</span>
                    </>
                  ) : (
                    <>
                      <span>Send Message</span>
                      <span className="material-symbols-outlined text-sm">send</span>
                    </>
                  )}
                </button>

                <div className="flex items-center justify-center gap-2 text-gray-500 text-xs pt-1">
                  <span className="material-symbols-outlined text-sm">lock</span>
                  <span>Protected by enterprise-grade medical encryption.</span>
                </div>
              </form>
            )}
          </div>
        </div>
      </main>
    </section>
  );
}

export default function Home() {
  const navigate = useNavigate();
  const styleInjected = useRef(false);

  useEffect(() => {
    if (styleInjected.current) return;
    styleInjected.current = true;
    const el = document.createElement("style");
    el.textContent = STYLES;
    document.head.appendChild(el);
  }, []);

  useEffect(() => {
    const sections = document.querySelectorAll("section[id]");
    const links    = document.querySelectorAll("#main-nav a[href^='#']");
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          links.forEach(l => l.classList.remove("nav-active"));
          const a = document.querySelector(`#main-nav a[href="#${e.target.id}"]`);
          if (a) a.classList.add("nav-active");
        }
      });
    }, { rootMargin: "-30% 0px -60% 0px" });
    sections.forEach(s => io.observe(s));
    return () => io.disconnect();
  }, []);

  return (
    <div className="text-white font-sans antialiased overflow-x-hidden min-h-screen relative">
      <GlobalBackground />
      <Navbar navigate={navigate} />
      <SectionHome navigate={navigate} />
      <SectionFeatures />
      <SectionPlatform />
      <SectionResources />
      <SectionCareer />
      <SectionContact />
    </div>
  );
}